
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"homeFeaturedCaseOrProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"home_home_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredCaseOrProject"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredProjectContent"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredCaseContent"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredPortfolioContent"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"projectoverViewFeaturedCaseOrProject"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projectOverview_projectOverview_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"featuredCaseOrProject"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"__typename"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"slug"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"title"},"arguments":[],"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredProjectContent"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredCaseContent"},"directives":[]},{"kind":"FragmentSpread","name":{"kind":"Name","value":"featuredPortfolioContent"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"featuredProjectContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"projects_projects_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredHTML"},"name":{"kind":"Name","value":"wysiwyg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"programCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programCategoryBasic"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"featuredCaseContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"case_case_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredHTML"},"name":{"kind":"Name","value":"wysiwyg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"programCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programCategoryBasic"},"directives":[]}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"featuredPortfolioContent"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"portfolio_portfolio_Entry"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"featuredHTML"},"name":{"kind":"Name","value":"wysiwyg"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"featuredImage"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"DefaultImageAsset"},"directives":[]}]}},{"kind":"Field","name":{"kind":"Name","value":"programCategory"},"arguments":[],"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"programCategoryBasic"},"directives":[]}]}}]}}],"loc":{"start":0,"end":1281}};
    doc.loc.source = {"body":"#import \"~/graphql/fragments/defaultImageAsset.graphql\"\n#import \"~/graphql/fragments/categories/programCategoryBasic.graphql\"\n\nfragment homeFeaturedCaseOrProject on home_home_Entry {\n    featuredCaseOrProject {\n        __typename\n        id\n        slug\n        title\n        ... featuredProjectContent\n        ... featuredCaseContent\n        ... featuredPortfolioContent\n    }\n}\n\nfragment projectoverViewFeaturedCaseOrProject on projectOverview_projectOverview_Entry {\n    featuredCaseOrProject {\n        __typename\n        id\n        slug\n        title\n        ... featuredProjectContent\n        ... featuredCaseContent\n        ... featuredPortfolioContent\n    }\n}\n\nfragment featuredProjectContent on projects_projects_Entry {\n    featuredHTML: wysiwyg\n    featuredImage {\n        ... DefaultImageAsset\n    }\n    programCategory {\n        ... programCategoryBasic\n    }\n}\n\nfragment featuredCaseContent on case_case_Entry {\n    featuredHTML: wysiwyg\n    featuredImage {\n        ... DefaultImageAsset\n    }\n    programCategory {\n        ... programCategoryBasic\n    }\n}\n\nfragment featuredPortfolioContent on portfolio_portfolio_Entry {\n    featuredHTML: wysiwyg\n    featuredImage {\n        ... DefaultImageAsset\n    }\n    programCategory {\n        ... programCategoryBasic\n    }\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/defaultImageAsset.graphql").definitions));
doc.definitions = doc.definitions.concat(unique(require("~/graphql/fragments/categories/programCategoryBasic.graphql").definitions));


    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["homeFeaturedCaseOrProject"] = oneQuery(doc, "homeFeaturedCaseOrProject");
        
        module.exports["projectoverViewFeaturedCaseOrProject"] = oneQuery(doc, "projectoverViewFeaturedCaseOrProject");
        
        module.exports["featuredProjectContent"] = oneQuery(doc, "featuredProjectContent");
        
        module.exports["featuredCaseContent"] = oneQuery(doc, "featuredCaseContent");
        
        module.exports["featuredPortfolioContent"] = oneQuery(doc, "featuredPortfolioContent");
        
